import { configureFor } from '../typeahead'

export default function configure() {
  configureFor('[name="edit-form"]')
  configureFor('[name="new-form"]')
}
